import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { SENTRY_DSN, SENTRY_ENV } from "config";
import { initializeSentry } from "utility/sentry";
import { store, persistor } from "./redux/store";
import App from "./App";

import "assets/scss/app.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

const sentryConfig = {
  dsn: SENTRY_DSN,
  environment: SENTRY_ENV,
};

initializeSentry(sentryConfig);

const app = (
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <App />
    </PersistGate>
  </Provider>
);

root.render(app);
